import { render, staticRenderFns } from "./MobileNav.vue?vue&type=template&id=2f48318e&scoped=true&"
import script from "./MobileNav.vue?vue&type=script&lang=js&"
export * from "./MobileNav.vue?vue&type=script&lang=js&"
import style0 from "./MobileNav.vue?vue&type=style&index=0&id=2f48318e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../igs3-fontend-prod353/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f48318e",
  null
  
)

export default component.exports